import React, { useEffect, useRef, useState } from 'react'
import { MemberMediaProps } from '../../../typings/memberMedia';
import NiceModal from "@ebay/nice-modal-react";
import { deleteMedia, getMemberMedia, switchToNextProfilePicture, uploadProfileImage, toggleProfilePicture } from '../../../services/mediaService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { setUserData } from '../../../redux/member';
import { convertBase64ToBlob, sendMessageToWebViewWrapper } from '../../../helpers/Functions';
import { MODAL_TYPES, useGlobalModalContext } from '../../../components/GlobalModal';
import ImageContainer from './ImageContainer';
import { Box, CircularProgress, Modal, Typography } from '@mui/material';
import LoadingIndiactorModal from '../../../components/modals/LoadingIndicatorModal';
import { revokeMemberImageVerficationStatus } from '../../../services/memberService';
import { setProfileMemberData } from '../../../redux/profileMember';
import { GenderType } from '../../../helpers/Enums';

type EditProfileImagesProps = {
    mediaData: MemberMediaProps[];
}

const EditProfileImages = ({ mediaData }: EditProfileImagesProps) => {
    const [profileImage, setProfileImage] = useState<MemberMediaProps | null>(null);
    const [images, setImages] = useState<MemberMediaProps[]>([]);

    const { showModal } = useGlobalModalContext();
    const member = useSelector((state: RootState) => state.member);
    const inputFile = useRef<any>(null)
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);



    useEffect(() => {
        mediaData.forEach(img => {
            if (img.isProfilePicture) {
                setProfileImage(img);
            } else {
                setImages(pre => [...pre, img]);
            }
        });
    }, [])

    // useEffect(() => {
    //     document.addEventListener('upload-image', (e: any) => onMobileImageSelected(e.detail.base64image));
    // }, [])

    const onMobileImageSelected = (base64image: string) => {
        showCropper(base64image);
    }

    //incase user deletes profile picture it will delete and switch to one of the subimages
    //if there is no subimages and he tries to delete profile img it will revoke his verification
    //otherwise will delete subimge
    const deleteImage = async (imageData: MemberMediaProps) => {
        NiceModal.hide("action_modal");
        try {
            if (imageData.isProfilePicture && images.length > 0) {
                const nextImage: MemberMediaProps = images[0];
                await switchToNextProfilePicture(imageData.mediaId, nextImage.mediaId);


                member.profilePicture = nextImage.mediaUrl;
                nextImage.isProfilePicture = true;
                setProfileImage(nextImage);
                dispatch(setUserData(member));
                setImages(images.filter(img => nextImage.mediaId !== img.mediaId));

            } else if (imageData.isProfilePicture) {
                await deleteMedia(member.memberCode, imageData.mediaId);
                await revokeMemberImageVerficationStatus();


                member.profileIsVerified = false;
                member.profilePicture = null;
                dispatch(setUserData(member));
                dispatch(setProfileMemberData({ showNoProfilePictureModal: true }));
                setProfileImage(null);
            } else {
                await deleteMedia(member.memberCode, imageData.mediaId);
                setImages(images.filter(img => imageData.mediaId !== img.mediaId));
            }
        } catch (error) {
            NiceModal.show("error_modal", {
                errorContent: "שגיאה לא צפויה בפעולת המחיקה",
            });
            console.log(error)
        }
    };

    const confirmDeleteImage = (imageData: MemberMediaProps) => {
        if (member.profileIsVerified && images.length === 0) {
            NiceModal.show("action_modal", {
                onNext: () => deleteImage(imageData),
                headerTitle: "אזהרה!",
                contentTitle: member.genderId === GenderType.MALE ? "האם אתה בטוח? מחיקת התמונה תבטל את אימות הפרופיל שלך" : "האם את בטוחה? מחיקת התמונה תבטל את אימות הפרופיל שלך",
                seconderyButtonText: "בעצם לא",
                primaryButtonText: "אפשר למחוק",
                showCloseButton: true,
                showSeconderyButton: true
            });
        } else {
            NiceModal.show("action_modal", {
                onNext: () => deleteImage(imageData),
                headerTitle: "רק מוודאים",
                contentTitle: "האם למחוק את התמונה?",
                seconderyButtonText: "בעצם לא",
                primaryButtonText: "אפשר למחוק",
                showCloseButton: true,
                showSeconderyButton: true
            });
        }
    };
    // delete image end

    const switchToProfilePicture = async (imageData: MemberMediaProps) => {
        try {
            await toggleProfilePicture(imageData.mediaId)
            member.profilePicture = imageData.mediaUrl;
            setProfileImage(imageData);
            dispatch(setUserData(member));
            updateMemberImageData();
        } catch (error) {
            console.log(error)
        }
    }


    const updateMemberImageData = async () => {
        const { data: media } = await getMemberMedia(member.memberCode);
        setProfileImage(null);
        setImages([]);
        media.forEach(img => {
            if (img.isProfilePicture) {
                setProfileImage(img);
            } else {
                setImages(pre => [...pre, img]);
            }
        });
    }




    // upload image start
    const openUploadFile = () => {
        // if (window.platform === 'android') {
        //     sendMessageToWebViewWrapper({
        //         action: 'openCamera',
        //         payload: { source: 'gallery' }
        //     })
        // } else {
        if (inputFile.current) {
            inputFile.current.click()
        }
        // }
    };

    const onSelectFile = (e: any) => {
        const imageFile = e.target.files[0]
        const reader = new FileReader();
        reader.readAsDataURL(imageFile)
        reader.onload = () => {
            showCropper(reader.result);
        };
    }

    const showCropper = (base64image: string | ArrayBuffer | null) => {
        showModal(MODAL_TYPES.IMAGE_CROPPER, {
            imgURL: base64image,
            setCropImage: uploadCropImage,
            buttonText: "שמור תמונה"
        });
    };

    const uploadCropImage = async (cropImage: any) => {
        try {
            setIsLoading(true);
            const res: any = await uploadProfileImage(member.memberCode, convertBase64ToBlob(cropImage), true);

            member.profilePicture = res.data.mediaUrl
            dispatch(setUserData(member));

            updateState();
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            NiceModal.show("error_modal", {
                headerTitle: "שגיאה",
                errorContent: "שגיאה לא צפויה",
            });
        }
    };

    const updateState = async () => {
        let temp: MemberMediaProps[] = [];
        const { data: media } = await getMemberMedia(member.memberCode);

        media.forEach(img => {
            if (img.isProfilePicture) {
                setProfileImage(img);
                member.profilePicture = img.mediaUrl;
                dispatch(setUserData(member));
            } else {
                temp = [...temp, img]
            }
        });
        setImages(temp);
    }
    // upload image end


    // <Box sx={{ display: 'flex' }}>
    //     <CircularProgress />
    // </Box>

    return (
        <div>
            <ul className="edit_pict_list w-clearfix w-list-unstyled">

                {/* profile image start ******************* */}

                {
                    profileImage !== null ?
                        <li className="edit_pict_item big">
                            <a href="#" className="edit_pict_link w-input delete w-inline-block"></a>
                            <img src={profileImage.mediaUrl} loading="lazy" alt="" className="item_pict" />
                            <a href="#" onClick={() => confirmDeleteImage(profileImage)} className="pict_minus w-inline-block">
                                <img src="/assets/images/ic_pict_close.svg" loading="lazy" alt="" />
                            </a>

                        </li>
                        :
                        <li className="edit_pict_item big" onClick={openUploadFile}>
                            <img loading="lazy" alt="" className="item_pict no_upload" />
                            <a href="#" className="edit_pict_link w-input delete w-inline-block"></a>
                            <input autoComplete="off" multiple={false} style={{ opacity: 0 }} onChange={onSelectFile} type="file" accept="image/*" ref={inputFile} />
                            <a href="#" className="pict_minus w-inline-block">
                                <img src="/assets/images/ic_pict_plus.svg" loading="lazy" alt="" />
                            </a>
                        </li>
                }

                {/* profile image end ******************* */}

                {
                    images.map(img => {
                        return <ImageContainer toggleIsLoading={() => { setIsLoading(preve => !preve) }} switchToProfilePicture={switchToProfilePicture} confirmDeleteImage={confirmDeleteImage} image={img} updateState={updateState} key={Math.random()} />
                    })
                }



                {
                    Array(5 - images.length).fill(0).map((img, index) => {
                        return <ImageContainer toggleIsLoading={() => { setIsLoading(preve => !preve) }} switchToProfilePicture={switchToProfilePicture} confirmDeleteImage={confirmDeleteImage} image={null} updateState={updateState} key={Math.random()} />
                    })
                }
            </ul>

            {isLoading && <LoadingIndiactorModal text="מעלה תמונה" />}
        </div>
    );
}

export default EditProfileImages;